export default __webpack_public_path__ + "static/wave22-mobile-3e0d599240fd10ee1e0443cef8ddee11.png";